import { Button } from "@anna-money/anna-web-ui";
import { type FC } from "react";
import { Link } from "components/Link/Link";
import { Paragraph } from "components/Paragraph/Paragraph";
import { Subtitle } from "components/Subtitle/Subtitle";
import styles from "./ErrorView.module.scss";

type ErrorViewProps = {
  retryTestId: string;
  onRetry: () => void;
};

export const ErrorView: FC<ErrorViewProps> = ({ retryTestId, onRetry }) => {
  return (
    <div className={styles.errorView}>
      <Subtitle className={styles.lessMargin}>ANNA couldn&apos;t load this page</Subtitle>
      <Paragraph className={styles.lessMargin}>Please try again</Paragraph>
      <Paragraph className={styles.lessMargin}>
        If it still doesn&apos;t work, email <Link href="mailto:formations@anna.money">formations@anna.money</Link> and
        we&apos;ll help you continue your application
      </Paragraph>
      <Button testId={retryTestId} text="Retry" className={styles.retryButton} onClick={onRetry} />
    </div>
  );
};
